<template>
  <div class="sample-mgmt-page purchase-mgmt-page">
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">产品类目</span>
            <el-select placeholder="全部" size="small" v-model="params.categoryType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="手机壳" :value="1"></el-option>
              <el-option label="手机支架" :value="2"></el-option>
              <el-option label="iPad保护壳" :value="4"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">当前 {{ samples.length }} 条 / 共 {{ total }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getSamples">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-plus" @click="onAddSampleClick">新增样品</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="content-panel">
      <div class="status-tabs-card">
        <el-tabs v-model="activeName" class="status-tabs" @tab-click="handleClick">
          <el-tab-pane name="waitSampleEvaluate">
            <span slot="label" class="status-tab-label">
              待采样评估
              <el-badge v-if="samplesStatistics.waitSampleEvaluateCount > 0" :value="samplesStatistics.waitSampleEvaluateCount" class="status-tab-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane name="waitPurchaseSample">
            <span slot="label" class="status-tab-label">
              待采样
              <el-badge v-if="samplesStatistics.waitPurchaseSampleCount > 0" :value="samplesStatistics.waitPurchaseSampleCount" class="status-tab-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane name="waitLinkToNewEvaluate">
            <span slot="label" class="status-tab-label">
              待上新评估
              <el-badge v-if="samplesStatistics.waitLinkToNewEvaluateCount > 0" :value="samplesStatistics.waitLinkToNewEvaluateCount" class="status-tab-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane name="waitLinkToNew">
            <span slot="label" class="status-tab-label">
              待上新
              <el-badge v-if="samplesStatistics.waitLinkToNewCount > 0" :value="samplesStatistics.waitLinkToNewCount" class="status-tab-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="已上新" name="alreadyLinkToNew"></el-tab-pane>
          <el-tab-pane label="已采样" name="alreadyPurchaseSample"></el-tab-pane>
          <el-tab-pane label="不上新" name="notLinkToNew"></el-tab-pane>
          <el-tab-pane label="不采样" name="notPurchaseSample"></el-tab-pane>
          <el-tab-pane label="全部" name="all"></el-tab-pane>
        </el-tabs>
      </div>

      <div class="table-panel" ref="tablePanel">
        <div class="table-container">
          <el-table
            :data="samples"
            border
            stripe
            size="mini"
            :height="screenHeight"
            class="mgmt-table"
            header-cell-class-name="table-header-cell"
            v-loading="loading"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
          >
          <el-table-column label="序号" width="52" align="center">
            <template slot-scope="scope">
              {{ params.beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="样品图片" width="88" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.sampleImgUrl"
                class="sample-thumb"
                :src="scope.row.sampleImgUrl"
                :preview-src-list="[scope.row.sampleImgUrl]"
                fit="cover"
              ></el-image>
              <span v-else class="text-muted">无图</span>
            </template>
          </el-table-column>
          <el-table-column label="类目" width="88" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" effect="plain">{{ getCategoryTypeLabel(scope.row.categoryType) || "-" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="店铺" width="72" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ getShopName(scope.row.shopType) }}
            </template>
          </el-table-column>
          <el-table-column prop="sampleName" label="样品名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="采样状态" width="88" align="center">
            <template slot-scope="scope">
              <el-tag :type="getPurchaseSampleStatusType(scope.row.purchaseSampleStatus)" size="mini" effect="plain">
                {{ getPurchaseSampleStatusLabel(scope.row.purchaseSampleStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="上新状态" width="88" align="center">
            <template slot-scope="scope">
              <el-tag :type="getLinkToNewStatusType(scope.row.linkToNewStatus)" size="mini" effect="plain">
                {{ getLinkToNewStatusLabel(scope.row.linkToNewStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="模型" width="72" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.modelStatus == 2 ? 'success' : 'info'" size="mini" effect="plain">
                {{ scope.row.modelStatus == 1 ? "无模型" : "有模型" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="原图" width="72" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.originalImgStatus == 2 ? 'success' : 'info'" size="mini" effect="plain">
                {{ scope.row.originalImgStatus == 1 ? "无原图" : "有原图" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="供应商报价" min-width="220">
            <template slot-scope="scope">
              <div class="supplier-list-cell">
                <div v-if="scope.row.supplier1Id" class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier1Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier1Name }}</span>
                  <span class="supplier-price" v-if="scope.row.supplier1Price > 0">¥{{ scope.row.supplier1Price.toFixed(2) }}</span>
                </div>
                <div v-if="scope.row.supplier2Id" class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier2Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier2Name }}</span>
                  <span class="supplier-price" v-if="scope.row.supplier2Price > 0">¥{{ scope.row.supplier2Price.toFixed(2) }}</span>
                </div>
                <div v-if="scope.row.supplier3Id" class="supplier-line">
                  <span class="main-label" v-if="scope.row.mainSupplierId && scope.row.mainSupplierId == scope.row.supplier3Id">主</span>
                  <span class="supplier-name">{{ scope.row.supplier3Name }}</span>
                  <span class="supplier-price" v-if="scope.row.supplier3Price > 0">¥{{ scope.row.supplier3Price.toFixed(2) }}</span>
                </div>
                <span v-if="!scope.row.supplier1Id && !scope.row.supplier2Id && !scope.row.supplier3Id" class="text-muted">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="competitorUrl" label="竞品链接" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="linkToNewDate" label="计划上新" width="96" align="center"></el-table-column>
          <el-table-column label="创建时间" width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.createDate" class="datetime-cell">
                <div>{{ splitDateTime(scope.row.createDate).date }}</div>
                <div class="datetime-time">{{ splitDateTime(scope.row.createDate).time }}</div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" min-width="280" fixed="right" align="center" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="small" @click="editSample(scope.row)">编辑</el-button>
                <el-button type="text" size="small" v-if="scope.row.purchaseSampleStatus == 1" @click="confirmPurchaseSample(scope.row.sampleId, 2)">确认采样</el-button>
                <el-button type="text" size="small" v-if="scope.row.purchaseSampleStatus == 2" @click="confirmPurchaseSample(scope.row.sampleId, 3)">确认已采样</el-button>
                <el-button type="text" size="small" v-if="scope.row.purchaseSampleStatus == 1 || scope.row.purchaseSampleStatus == 2" @click="confirmPurchaseSample(scope.row.sampleId, 4)">确认不采样</el-button>
                <el-button type="text" size="small" v-if="scope.row.linkToNewStatus == 1 && activeName == 'waitLinkToNewEvaluate'" @click="confirmLinkToNew(scope.row.sampleId, 2)">确认待上新</el-button>
                <el-button type="text" size="small" v-if="scope.row.linkToNewStatus == 2 && activeName == 'waitLinkToNew'" @click="handleLinkToNew(scope.row, 3)">确认上新</el-button>
                <el-button type="text" size="small" v-if="scope.row.linkToNewStatus == 1 || scope.row.linkToNewStatus == 2" @click="confirmLinkToNew(scope.row.sampleId, 4)">确认不上新</el-button>
                <el-button type="text" size="small" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
            ref="pageNav"
            layout="prev, pager, next, total"
            background
            prev-text="上一页"
            next-text="下一页"
            :page-count="pageCount"
            :page-size="params.pageSize"
            :total="total"
            @prev-click="prevBtnClick"
            @next-click="nextBtnClick"
            @current-change="curBtnClick"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="新增样品"
      :visible.sync="sampleDialogVisible"
      :close-on-click-modal="false"
      width="1000px"
      @opened="onSampleDialogOpened"
      @closed="onSampleDialogClosed"
    >
      <div class="form-line">
        <span class="form-label"><span>*</span>样品名称</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.sampleName" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>样品照片</span>

        <el-upload class="avatar-uploader" action="/biz/oss/upload" :show-file-list="false" :on-success="handleAvatarSuccess" style="width: 200px; display: inline-block; vertical-align: top">
          <img v-if="sampleInfo.sampleImgUrl" :src="sampleInfo.sampleImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span class="sample-img-paste-tip">支持点击上传，或 Ctrl+V 粘贴截图</span>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>产品类目</span>
        <el-radio-group v-model="sampleInfo.categoryType">
          <el-radio :label="1">手机壳</el-radio>
          <el-radio :label="2">手机支架</el-radio>
          <el-radio :label="4">iPad保护壳</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>店铺</span>
        <el-radio-group v-model="sampleInfo.shopType">
          <el-radio :label="1">灵柚</el-radio>
          <el-radio :label="2">萧发</el-radio>
          <el-radio :label="3">誉腾</el-radio>
          <el-radio :label="4">甄昂</el-radio>
          <!-- <el-radio :label="5">杭傲</el-radio> -->
          <el-radio :label="8">众联</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>样品状态</span>
        <el-radio-group v-model="sampleInfo.purchaseSampleStatus">
          <el-radio :label="1">待采样评估</el-radio>
          <el-radio :label="2">待采样</el-radio>
          <el-radio :label="3">已采样</el-radio>
          <el-radio :label="4">不采样</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>上新状态</span>
        <el-radio-group v-model="sampleInfo.linkToNewStatus">
          <el-radio :label="1">待上新评估</el-radio>
          <el-radio :label="2">待上新</el-radio>
          <el-radio :label="3">已上新</el-radio>
          <el-radio :label="4">不上新</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>模型状态</span>
        <el-radio-group v-model="sampleInfo.modelStatus">
          <el-radio :label="1">无模型</el-radio>
          <el-radio :label="2">有模型</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>原图状态</span>
        <el-radio-group v-model="sampleInfo.originalImgStatus">
          <el-radio :label="1">无原图</el-radio>
          <el-radio :label="2">有原图</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商1</span>
        <el-select placeholder="产品类型" size="small" v-model="sampleInfo.supplier1Id" filterable style="width: 200px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.supplier1Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 10px">元</span>
        <el-radio v-model="sampleInfo.mainSupplierId" :label="sampleInfo.supplier1Id" v-if="sampleInfo.supplier1Id">{{ sampleInfo.mainSupplierId == sampleInfo.supplier1Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商2</span>
        <el-select placeholder="产品类型" size="small" v-model="sampleInfo.supplier2Id" filterable style="width: 200px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.supplier2Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 10px">元</span>
        <el-radio v-model="sampleInfo.mainSupplierId" :label="sampleInfo.supplier2Id" v-if="sampleInfo.supplier2Id">{{ sampleInfo.mainSupplierId == sampleInfo.supplier2Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>采购供应商3</span>
        <el-select placeholder="产品类型" size="small" v-model="sampleInfo.supplier3Id" filterable style="width: 200px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in suppliers" :key="supplier.supplierId" :label="supplier.supplierName" :value="supplier.supplierId"></el-option>
        </el-select>

        <span class="form-label">采购价格</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.supplier3Price" size="small" clearable style="width: 100px; vertical-align: middle"> </el-input>
        <span style="margin-left: 10px; margin-right: 10px">元</span>
        <el-radio v-model="sampleInfo.mainSupplierId" :label="sampleInfo.supplier3Id" v-if="sampleInfo.supplier3Id">{{ sampleInfo.mainSupplierId == sampleInfo.supplier3Id ? "主要供应商" : "" }}</el-radio>
      </div>
      <div class="form-line">
        <span class="form-label">竞品链接</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.competitorUrl" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">计划上新日期</span>
        <el-date-picker v-model="sampleInfo.linkToNewDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input class="form-input" placeholder="请输入" v-model="sampleInfo.remark" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sampleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认上新" :visible.sync="linkToNewDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label"><span>*</span>产品类型</span>
        <el-radio-group v-model="linkToNewInfo.createType">
          <el-radio :label="1">新增商品</el-radio>
          <el-radio :label="2">已有商品</el-radio>
          <!-- <el-radio :label="3">不绑定商品</el-radio> -->
        </el-radio-group>
      </div>

      <template v-if="linkToNewInfo.createType == 1">
        <div class="form-line">
          <span class="form-label"><span>*</span>店铺名称</span>
          <el-radio-group v-model="linkToNewInfo.shopType">
            <el-radio :label="1">灵柚</el-radio>
            <el-radio :label="2">萧发</el-radio>
            <el-radio :label="3">誉腾</el-radio>
            <el-radio :label="4">甄昂</el-radio>
            <el-radio :label="8">众联</el-radio>
          </el-radio-group>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>产品类目</span>
          <el-radio-group v-model="linkToNewInfo.categoryType">
            <el-radio :label="1">手机壳</el-radio>
            <el-radio :label="2">手机支架</el-radio>
            <el-radio :label="4">iPad保护壳</el-radio>
          </el-radio-group>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>产品名称</span>
          <el-input class="form-input" placeholder="请输入" v-model="linkToNewInfo.productName" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>SKU前缀</span>
          <el-input class="form-input" placeholder="请输入" v-model="linkToNewInfo.skuPrefix" size="small" clearable> </el-input>
        </div>
      </template>
      <!-- <template v-if="linkToNewInfo.createType == 2">
        <div class="form-line">
          <span class="form-label">产品类型</span>
          <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="product in parentProducts" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
          </el-select>
        </div>
      </template> -->

      <template v-if="linkToNewInfo.createType == 1 || linkToNewInfo.createType == 2">
        <div class="form-line">
          <span class="form-label"><span>*</span>材料1名称</span>
          <el-input class="form-input" placeholder="请输入" v-model="linkToNewInfo.sample1Name" size="small" clearable> </el-input>
          <div class="supplier-Line" v-if="currentSample.supplier1Name">
            <span class="supplier-name">供应商1：{{ currentSample.supplier1Name }}</span
            >, 采购价：{{ currentSample.supplier1Price }} 元
          </div>
          <div class="supplier-Line" v-if="currentSample.supplier2Name">
            <span class="supplier-name">供应商2：{{ currentSample.supplier2Name }}</span
            >, 采购价：{{ currentSample.supplier2Price }} 元
          </div>
          <div class="supplier-Line" v-if="currentSample.supplier3Name">
            <span class="supplier-name">供应商3：{{ currentSample.supplier3Name }}</span
            >, 采购价：{{ currentSample.supplier3Price }} 元
          </div>
        </div>

        <div class="form-line">
          <span class="form-label"><span>*</span>材料2名称</span>
          <el-input class="form-input" placeholder="请输入" v-model="linkToNewInfo.sample2Name" size="small" clearable> </el-input>
        </div>
        <div class="form-line">
          <span class="form-label"><span>*</span>材料3名称</span>
          <el-input class="form-input" placeholder="请输入" v-model="linkToNewInfo.sample3Name" size="small" clearable> </el-input>
        </div>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="linkToNewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmLinkToNew">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="1200px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" class="record-table">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules, ossModules } from "@r";
import { colors, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      total: 0,
      pageCount: 1,
      screenHeight: 400,
      loading: false,
      sampleImgUploading: false,
      sampleDialogVisible: false,
      linkToNewDialogVisible: false,
      activeName: "waitSampleEvaluate",
      productInfo: {},
      samples: [],
      competitorInfo: {},
      samplesStatistics: {
        waitSampleEvaluateCount: 0,
        waitPurchaseSampleCount: 0,
        waitLinkToNewEvaluateCount: 0,
        waitLinkToNewCount: 0,
      },
      params: { beginIndex: 0, pageSize: 50, purchaseSampleStatus: 1, linkToNewStatus: 1, categoryType: "" },
      sampleInfo: {
        sampleId: -1,
        sampleName: "",
        shopType: 1,
        purchaseSampleStatus: 1,
        linkToNewStatus: 1,
        modelStatus: 1,
        originalImgStatus: 1,
        supplier1Id: "",
        supplier1Name: "",
        supplier1Price: 0,
        supplier2Id: "",
        supplier2Name: "",
        supplier2Price: 0,
        supplier3Id: "",
        supplier3Name: "",
        supplier3Price: 0,
        competitorUrl: "",
        remark: "",
        linkToNewDate: "",
        mainSupplierId: "",
        sampleImgUrl: "",
        categoryType: 1,
      },
      suppliers: [],
      linkToNewInfo: {
        createType: 1,
        shopType: 1,
        categoryType: 1,
        productName: "",
        skuPrefix: "",
        sample1Name: "",
        sample2Name: "",
        sample3Name: "",
        productType: "",
      },
      parentProducts: [],
      currentSample: {},
      opreateLogVisible: false,
      operateHistory: [],
    };
  },
  mounted() {
    this.getSamples();
    this.getSuppliers();
    this.getAllParentProducts();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
    document.removeEventListener("paste", this.handleSampleImgPaste);
  },
  methods: {
    onSampleDialogOpened() {
      document.addEventListener("paste", this.handleSampleImgPaste);
    },
    onSampleDialogClosed() {
      document.removeEventListener("paste", this.handleSampleImgPaste);
      this.sampleImgUploading = false;
    },
    isSampleImgFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      const name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    handleSampleImgPaste(event) {
      if (!this.sampleDialogVisible || this.sampleImgUploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadSampleImgFile(file);
          }
          return;
        }
      }
    },
    uploadSampleImgFile(file) {
      if (!this.isSampleImgFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "sample");
      this.sampleImgUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.sampleInfo.sampleImgUrl = res.objData.fileUrl;
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.sampleImgUploading = false;
        });
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    getPurchaseSampleStatusType(status) {
      if (status == 2) {
        return "warning";
      }
      if (status == 3) {
        return "success";
      }
      if (status == 4) {
        return "info";
      }
      return "";
    },
    getLinkToNewStatusType(status) {
      if (status == 2) {
        return "warning";
      }
      if (status == 3) {
        return "success";
      }
      if (status == 4) {
        return "info";
      }
      return "";
    },
    handleAvatarSuccess(res, file) {
      this.sampleInfo.sampleImgUrl = res.objData.fileUrl;
      // this.sampleInfo.imageUrl = URL.createObjectURL(file.raw);
      console.log(this.sampleInfo.sampleImgUrl);
    },
    getAllParentProducts() {
      requestModules.fetchParentProducts({ status: 1 }).then(res => {
        this.parentProducts = res.ldata;
        this.parentProducts.sort((a, b) => b.productType - a.productType);
      });
    },
    getSuppliers() {
      requestModules.fetchSuppliers().then(res => {
        this.suppliers = res.ldata;
      });
    },
    getSampleStatics() {
      requestModules.getSampleStatics(this.params).then(res => {
        this.samplesStatistics = res.mdata;
      });
    },
    splitDateTime(value) {
      if (!value) {
        return { date: "-", time: "" };
      }
      const parts = String(value).trim().split(/\s+/);
      return {
        date: parts[0] || "-",
        time: parts[1] || "",
      };
    },
    getCategoryTypeLabel(categoryType) {
      let label = "";
      categoryType == 1 && (label = "手机壳");
      categoryType == 2 && (label = "手机支架");
      categoryType == 4 && (label = "iPad保护壳");
      return label;
    },
    confirmPurchaseSample(sampleId, purchaseSampleStatus) {
      let params = { sampleId, purchaseSampleStatus };
      purchaseSampleStatus == 3 && params.linkToNewStatus == 2;

      let text = "";
      purchaseSampleStatus == 2 && (text = "是否确认允许采样？");
      purchaseSampleStatus == 3 && (text = "是否确认已采样？");
      purchaseSampleStatus == 4 && (text = "是否确认不采样？");

      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestModules
          .addOrUpdateSample({ sampleId, purchaseSampleStatus })
          .then(res => {
            if (res.result !== 1) {
              this.$message({
                type: "error",
                message: res.message ? res.message : "编辑失败",
              });
              return;
            }
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.getSamples();
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    confirmLinkToNew(sampleId, linkToNewStatus) {
      let text = "";
      linkToNewStatus == 2 && (text = "是否确认上新？");
      linkToNewStatus == 3 && (text = "是否确认已上新？");
      linkToNewStatus == 4 && (text = "是否确认不上新？");

      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.addOrUpdateSample(sampleId, linkToNewStatus);
      });
    },
    addOrUpdateSample(sampleId, linkToNewStatus) {
      requestModules
        .addOrUpdateSample({ sampleId, linkToNewStatus })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getSamples();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleLinkToNew(sample, linkToNewStatus) {
      this.currentSample = sample;
      this.linkToNewInfo = {
        createType: 1,
        shopType: 1,
        categoryType: sample.categoryType,
        productName: sample.sampleName,
        skuPrefix: "",
        sample1Name: sample.sampleName,
        sample2Name: "",
        sample3Name: "",
        productType: "",
      };
      this.linkToNewDialogVisible = true;
    },
    handleConfirmLinkToNew() {
      this.addOrUpdateSample(this.currentSample.sampleId, 3);
      if (this.linkToNewInfo.createType == 1 || this.linkToNewInfo.createType == 2) {
        this.createMaterial();
      }
      if (this.linkToNewInfo.createType == 1) {
        this.createParentProduct();
      }

      this.linkToNewDialogVisible = false;
    },
    createParentProduct() {
      let product = {
        shopType: this.linkToNewInfo.shopType,
        categoryType: this.linkToNewInfo.categoryType,
        productName: this.linkToNewInfo.productName,
        skuPrefix: this.linkToNewInfo.skuPrefix,
        skuPrefix2: "",
        searchTerms: "",
        des1: "",
        des2: "",
        des3: "",
        des4: "",
        des5: "",
        defaultModel: "",
        defaultColor: "",
        cost: 0,
        isHasModel: 0,
        title: "",
        status: 1,
        country: 1,
        isMajorProduct: 1,
        perSKUOrderQuantity: 5,
        checkColors: JSON.stringify([]),
        checkModels: JSON.stringify([]),
        shopName: this.getShopName(this.linkToNewInfo.shopType),
        materialConfig: JSON.stringify([]),
      };
      requestModules
        .updateParentProduct(product)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    createMaterial() {
      let materials = [];
      if (this.linkToNewInfo.sample1Name != "") {
        materials.push({
          materialId: -1,
          materialName: this.linkToNewInfo.sample1Name,
          colorList: [],
          des: "",
          supplier1Id: this.currentSample.supplier1Id,
          supplier1Name: this.currentSample.supplier1Name,
          supplier1Price: this.currentSample.supplier1Price,
          supplier2Id: this.currentSample.supplier2Id,
          supplier2Name: this.currentSample.supplier2Name,
          supplier2Price: this.currentSample.supplier2Price,
          supplier3Id: this.currentSample.supplier3Id,
          supplier3Name: this.currentSample.supplier3Name,
          supplier3Price: this.currentSample.supplier3Price,
          mainSupplierId: this.currentSample.mainSupplierId,
        });
      }
      if (this.linkToNewInfo.sample2Name != "") {
        materials.push({
          materialId: -1,
          materialName: this.linkToNewInfo.sample2Name,
          colorList: [],
          des: "",
          supplier1Id: "",
          supplier1Name: "",
          supplier1Price: "",
          supplier2Id: "",
          supplier2Name: "",
          supplier2Price: "",
          supplier3Id: "",
          supplier3Name: "",
          supplier3Price: "",
          mainSupplierId: "",
        });
      }
      if (this.linkToNewInfo.sample3Name != "") {
        materials.push({
          materialId: -1,
          materialName: this.linkToNewInfo.sample3Name,
          colorList: [],
          des: "",
          supplier1Id: "",
          supplier1Name: "",
          supplier1Price: "",
          supplier2Id: "",
          supplier2Name: "",
          supplier2Price: "",
          supplier3Id: "",
          supplier3Name: "",
          supplier3Price: "",
          mainSupplierId: "",
        });
      }

      if (materials.length > 0) {
        let params1 = { ...materials[0] };
        params1.colorList = JSON.stringify(params1.colorList);
        requestModules
          .addOrUpdateMaterial(params1)
          .then(res => {
            if (materials.length > 1) {
              let params2 = { ...materials[1] };
              params2.colorList = JSON.stringify(params2.colorList);
              requestModules
                .addOrUpdateMaterial(params2)
                .then(res => {
                  if (materials.length > 2) {
                    let params3 = { ...materials[2] };
                    params3.colorList = JSON.stringify(params3.colorList);
                    requestModules
                      .addOrUpdateMaterial(params3)
                      .then(res => {})
                      .catch(err => {
                        this.$message({
                          type: "error",
                          message: err.message ? err.message : "未知错误",
                        });
                      });
                  }
                })
                .catch(err => {
                  this.$message({
                    type: "error",
                    message: err.message ? err.message : "未知错误",
                  });
                });
            }
          })
          .catch(err => {
            this.$message({
              type: "error",
              message: err.message ? err.message : "未知错误",
            });
          });
      }

      this.dialogFormVisible = false;

      // materials.forEach(material => {
      //   let params = { ...material };
      //   params.colorList = JSON.stringify(material.colorList);
      //   requestModules
      //     .addOrUpdateMaterial(params)
      //     .then(res => {
      //       this.dialogFormVisible = false;
      //     })
      //     .catch(err => {
      //       this.$message({
      //         type: "error",
      //         message: err.message ? err.message : "未知错误",
      //       });
      //     });
      // });
    },
    getLinkToNewStatusLabel(status) {
      let label = "";
      status == 1 && (label = "待定");
      status == 2 && (label = "待上新");
      status == 3 && (label = "已上新");
      status == 4 && (label = "不上新");
      return label;
    },
    getPurchaseSampleStatusLabel(status) {
      let label = "";
      status == 1 && (label = "待定");
      status == 2 && (label = "待采样");
      status == 3 && (label = "已采样");
      status == 4 && (label = "不采样");
      return label;
    },
    getSamples() {
      this.loading = true;
      requestModules
        .fetchSamples(this.params)
        .then(res => {
          this.samples = res.ldata || [];
          this.total = res.total || 0;
          this.getSampleStatics();
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    onAddSampleClick() {
      this.sampleDialogVisible = true;

      this.sampleInfo = {
        sampleId: -1,
        sampleName: "",
        purchaseSampleStatus: 1,
        linkToNewStatus: 1,
        modelStatus: 1,
        originalImgStatus: 1,
        supplier1Id: "",
        supplier1Name: "",
        supplier1Price: 0,
        supplier2Id: "",
        supplier2Name: "",
        supplier2Price: 0,
        supplier3Id: "",
        supplier3Name: "",
        supplier3Price: 0,
        competitorUrl: "",
        remark: "",
        linkToNewDate: "",
        mainSupplierId: "",
        sampleImgUrl: "",
        shopType: 1,
        categoryType: 1,
      };

      // requestModules
      //   .ossUpload({})
      //   .then(res => {
      //     if (res.result !== 1) {
      //       this.$message({
      //         type: "error",
      //         message: res.message ? res.message : "编辑失败",
      //       });
      //       return;
      //     }
      //     this.$message({
      //       type: "success",
      //       message: "操作成功!",
      //     });
      //     this.getSamples();
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    editSample(sample) {
      this.sampleDialogVisible = true;
      this.sampleInfo = { ...sample };
    },
    showOpreateLog(row) {
      this.operateHistory = [];
      this.opreateLogVisible = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: String(row.sampleId),
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        });
    },
    handleClick(tab, event) {
      let name = tab.name;
      this.activeName = name;
      this.params.purchaseSampleStatus = null;
      this.params.linkToNewStatus = null;

      if (name == "waitSampleEvaluate") {
        this.params.purchaseSampleStatus = 1;
      } else if (name == "waitPurchaseSample") {
        this.params.purchaseSampleStatus = 2;
      } else if (name == "waitLinkToNewEvaluate") {
        this.params.purchaseSampleStatus = 3;
        this.params.linkToNewStatus = 1;
      } else if (name == "waitLinkToNew") {
        this.params.linkToNewStatus = 2;
      } else if (name == "alreadyLinkToNew") {
        this.params.linkToNewStatus = 3;
      } else if (name == "notLinkToNew") {
        this.params.linkToNewStatus = 4;
      } else if (name == "notPurchaseSample") {
        this.params.purchaseSampleStatus = 4;
      } else if (name == "alreadyPurchaseSample") {
        this.params.purchaseSampleStatus = 3;
      } else {
      }
      this.getSamples();
    },
    handleConfirmBtn() {
      this.sampleInfo.shopName = this.getShopName(this.sampleInfo.shopType);
      this.sampleInfo.supplier1Name = this.getSupplierName(this.sampleInfo.supplier1Id);
      this.sampleInfo.supplier2Name = this.getSupplierName(this.sampleInfo.supplier2Id);
      this.sampleInfo.supplier3Name = this.getSupplierName(this.sampleInfo.supplier3Id);
      requestModules
        .addOrUpdateSample(this.sampleInfo)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getSamples();

          this.sampleDialogVisible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getShopName(shopType) {
      let shopName = "灵柚";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    getSupplierName(supplierId) {
      let supplier = this.suppliers.find(supplier => supplier.supplierId == supplierId);
      let supplierName = "";
      if (supplier) {
        supplierName = supplier.supplierName;
      }
      return supplierName;
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getSamples();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.sample-mgmt-page {
  .header-box {
    padding: 10px;

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .content-panel {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;
  }

  .status-tabs-card {
    flex-shrink: 0;
    background: #fff;
    border-radius: 8px;
    padding: 0 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;
  }

  .table-panel {
    flex: 1;
  }

  .sample-thumb {
    width: 64px;
    height: 64px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    vertical-align: middle;
  }

  .supplier-list-cell {
    line-height: 1.5;
  }

  .supplier-line {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;

    & + .supplier-line {
      margin-top: 2px;
    }
  }

  .supplier-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .supplier-price {
    flex-shrink: 0;
    color: #e6a23c;
    font-variant-numeric: tabular-nums;
    font-size: 12px;
  }

  .main-label {
    flex-shrink: 0;
    color: #fff;
    background-color: #f56c6c;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 10px;
    border-radius: 9px;
  }

  .text-muted {
    color: #c0c4cc;
  }

  .datetime-cell {
    line-height: 1.4;
  }

  .datetime-time {
    color: #909399;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }

  .action-cell {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 2px 4px;
    white-space: normal;
    line-height: 1.4;

    .el-button--text {
      padding: 0 4px;
      margin: 0;
    }
  }

  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 100px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
      .el-radio {
        width: 70px;
      }
    }
    .supplier-Line {
      margin-left: 110px;
      .supplier-name {
        display: inline-block;
        width: 260px;
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .sample-img-paste-tip {
      display: inline-block;
      margin-left: 12px;
      vertical-align: top;
      color: #909399;
      font-size: 12px;
      line-height: 178px;
    }
  }
}
</style>
